var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.lang
    ? _c(
        "modal",
        {
          ref: "custom-offer",
          attrs: {
            name: "custom-offer",
            "extra-class": "full-screen-modal custom-offer-modal",
            title: _vm.trans("title")
          }
        },
        [
          _c("template", { slot: "body" }, [
            _c("div", { staticClass: "custom-offer-form" }, [
              _c(
                "form",
                {
                  on: {
                    submit: function($event) {
                      $event.preventDefault()
                      return _vm.sendLead.apply(null, arguments)
                    },
                    keydown: function($event) {
                      return _vm.form.errors.clear($event.target.name)
                    }
                  }
                },
                [
                  _c(
                    "div",
                    { staticClass: "form-group" },
                    [
                      _c("my-input", {
                        attrs: {
                          type: "text",
                          label: _vm.trans("labels.offer")
                        },
                        on: { input: _vm.formatOffer },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "append",
                              fn: function() {
                                return [
                                  _vm._v(
                                    "\n                            €\n                        "
                                  )
                                ]
                              },
                              proxy: true
                            }
                          ],
                          null,
                          false,
                          3842255743
                        ),
                        model: {
                          value: _vm.formatted_offer,
                          callback: function($$v) {
                            _vm.formatted_offer = $$v
                          },
                          expression: "formatted_offer"
                        }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.form.offer,
                            expression: "form.offer"
                          }
                        ],
                        attrs: { type: "hidden", name: "offer" },
                        domProps: { value: _vm.form.offer },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(_vm.form, "offer", $event.target.value)
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("error-span", {
                        attrs: { error: _vm.form.errors.get("offer") }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "form-group" },
                    [
                      _c("my-input", {
                        attrs: {
                          name: "email",
                          type: "email",
                          label: _vm.trans("labels.email")
                        },
                        model: {
                          value: _vm.form.email,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "email", $$v)
                          },
                          expression: "form.email"
                        }
                      }),
                      _vm._v(" "),
                      _c("error-span", {
                        attrs: { error: _vm.form.errors.get("email") }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "form-group" },
                    [
                      _c("my-input", {
                        attrs: {
                          name: "phone",
                          type: "phone",
                          label: _vm.trans("labels.phone")
                        },
                        model: {
                          value: _vm.form.phone,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "phone", $$v)
                          },
                          expression: "form.phone"
                        }
                      }),
                      _vm._v(" "),
                      _c("error-span", {
                        attrs: { error: _vm.form.errors.get("phone") }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "form-group" },
                    [
                      _c("my-input", {
                        attrs: {
                          name: "first_name",
                          label: _vm.trans("labels.first_name")
                        },
                        model: {
                          value: _vm.form.first_name,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "first_name", $$v)
                          },
                          expression: "form.first_name"
                        }
                      }),
                      _vm._v(" "),
                      _c("error-span", {
                        attrs: { error: _vm.form.errors.get("first_name") }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "form-group" },
                    [
                      _c("my-input", {
                        attrs: {
                          name: "last_name",
                          label: _vm.trans("labels.last_name")
                        },
                        model: {
                          value: _vm.form.last_name,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "last_name", $$v)
                          },
                          expression: "form.last_name"
                        }
                      }),
                      _vm._v(" "),
                      _c("error-span", {
                        attrs: { error: _vm.form.errors.get("last_name") }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "privacy-policy",
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.trans("agreements.privacy", {
                          link: _vm.lang.agreements.link
                        })
                      )
                    }
                  }),
                  _vm._v(" "),
                  _c("button", { staticClass: "btn btn-network" }, [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.trans("labels.send")) +
                        "\n                "
                    )
                  ])
                ]
              )
            ])
          ])
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }